import { addMaintenance, deleteMaintenanceById, getAllMaintenance, getMaintenanceById, updateMaintenance, updateStatusMaintenance } from "../../../helpers/backend_helper";
import { getMaintenanceByIdError, getMaintenanceByIdSuccess, maintenanceEditSuccess, maintenanceError, maintenanceRequest, maintenanceSuccess } from "./reducer";

export const fetchMaintenance = (page:number,count:number,keyword:string) => async (dispatch: any) => {
    dispatch(maintenanceRequest());
    try {
      const response: any = await getAllMaintenance(page,count,keyword);
      if (response && response.isSuccess) {
        dispatch(maintenanceSuccess(response.data));
        return response
      } else {
        dispatch(maintenanceError("Failed to fetch Maintenance"));
        return response
      }
    } catch (error: any) {
      dispatch(maintenanceError(error.message));
      return null
    }
  };

  
  export const addNewMaintenance = (data: any) => async (dispatch: any) => {
    dispatch(maintenanceRequest());
    try {
      const response: any = await addMaintenance(data);
      if (response && response.data) {
        dispatch(maintenanceSuccess(response.data));
        return response 
      } else {
        dispatch(maintenanceError("Failed to add maintenance"));
      }
    } catch (error: any) {
      dispatch(maintenanceError(error.message));
    }
  };
  
  export const editMaintenance = (data: any) => async (dispatch: any) => {
    dispatch(maintenanceRequest());
    try {
      const response: any = await updateMaintenance(data);
      if (response.data && response.isSuccess) {
        dispatch(maintenanceSuccess(response));
        return response 
      } else {
        dispatch(maintenanceError("Failed to edit maintenance"));
        return response 
      }
    } catch (error: any) {
      dispatch(maintenanceError(error.message));
      return null
    }
  };
 
  export const fetchMaintenanceById = (userId: string) => async (dispatch: any) => {
    dispatch(maintenanceRequest());
    try {
      const response: any = await getMaintenanceById(userId);  
  
      if (response && response.isSuccess) {
        dispatch(getMaintenanceByIdSuccess(response.data)); 
        return response;  
      } else {
        dispatch(getMaintenanceByIdError("Failed to fetch maintenance by ID"));
        return null; 
      }
    } catch (error: any) {
      dispatch(getMaintenanceByIdError(error.message));  
      return null;
    }
  };

export const deleteMaintenance = (id: string) => async (dispatch :any) => {
  dispatch(maintenanceRequest());
  try {
    const response: any = await deleteMaintenanceById(id);  
    if (response && response.isSuccess) {
      dispatch(maintenanceSuccess(response.data)); 
      return response;  
    } else {
      dispatch(maintenanceError("Failed to fetch maintenance by ID"));
      return null; 
    }
  } catch (error: any) {
    dispatch(maintenanceError(error.message));  
    return null;
  }
}

export const updateStatus = (id: string, status: string) => async (dispatch: any) => {
  dispatch(maintenanceRequest());
  try {
    const response: any = await updateStatusMaintenance( id, status );
    if (response && response.isSuccess) {
      dispatch(maintenanceSuccess(response.data));
      return response
    } else {
      dispatch(maintenanceError("Failed to update status"));
      return response
    }
  } catch (error: any) {
    dispatch(maintenanceError(error.message));
    return null
  }
}
